<template>
    <div class="cover" v-if="!!error">
        <div class="banner">
            <h2>{{$t(`mensajes['${error}'].titulo`)}}</h2>
            <p>{{$t(`mensajes['${error}'].cuerpo`)}}</p>
            <a @click="eraseError" class="btn red">Aceptar</a>
        </div>
    </div>
</template>


<script>

    import {mapGetters, mapActions} from 'vuex';

    export default{
        name : 'message-banner',
        methods : {
            ...mapActions(['eraseError']),
        },
        computed:{
            ...mapGetters({
                error : 'getError'
            })
        }
        
    }

</script>

<style lang="scss" scoped>
    .cover {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background: rgba(0, 0, 0, .8);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
    }

    .banner {
        width: 100%;
        padding: 20px;
        background: white;
        display: inline-block;
        max-width: 400px;

        h2{
            font-weight: bold;
        }

        p{
            margin-top: 10px;
        }

        .btn{
            margin-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/message-banner.vue